<template>
<div>
    <el-table v-loading="loading.conferences" :data="conferences">
        <el-table-column min-width="110" label="Date">
            <div slot-scope="{ row }">
                <span> {{ moment(row.datetime).format('LLL')}}</span>
            </div>
        </el-table-column>
        <el-table-column min-width="90" label="Duration">
            <div slot-scope="{ row }">
                <span> {{ moment.duration(row.duration,'seconds').format("h [hrs], m [min]") }}</span>
            </div>
        </el-table-column>
        <el-table-column label="Attendance" min-width="130">
            <div slot-scope="{ row }">
                <base-progress
                    :animated="true"
                    size="md"
                    :value=" parseInt(row.attendance * 100)"
                    :label="Object.keys(row.attendees).length + '/' + row.student_count + ' students'"
                    value-position="right"
                />
            </div>
        </el-table-column>
        <el-table-column label="Actions" min-width="50" align="right">
            <div slot-scope="{ row }">
                <base-button type="primary" @click="selectConference(row)">
                    Details
                </base-button>
            </div>
        </el-table-column>
    </el-table>
    <conference-detail-modal v-if="showDetailModal" :classroom_id="classroom.id"
                             :conference_id="selectedConference.id"
                             @close="showDetailModal =  false"/>
</div>

</template>

<script>
    import axios from "axios";
    import {BaseProgress} from 'src/components';
    import ConferenceDetailModal from "./ConferenceDetailsModal";

    export default {
        name: "ConferenceOverview",
        components: {
            ConferenceDetailModal,
            BaseProgress,
        },
        props:['classroom'],
        data() {
            return {
                conferences: null,
                showDetailModal: false,
                selectedConference: null,
                loading: {
                    conferences: true,
                }
            };
        },
        mounted() {
            this.loadConferences();
        },
        methods: {
            selectConference(row) {
                this.selectedConference = row;
                this.showDetailModal = true;
            },
            loadConferences() {
                this.loading.conferences = true;
                return axios({
                    url: this.baseAPIURL + 'classroom/' + this.classroom.id + '/conference',
                    method: 'GET',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.conferences = resp.data.data;
                }).finally(() => {
                    this.loading.conferences = false;
                });
            },
        }
    }
</script>

<style scoped>

</style>
